import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ElementConditionLogic } from 'icreate/common/models/element-condition-logic';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ElementConditionLogicService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.get<ElementConditionLogic[]>(`${this.domain}/api/elementConditionLogic`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async create(elementConditionLogicData: ElementConditionLogic[]) {
        return await lastValueFrom(
            this.http.post<ElementConditionLogic[]>(
                `${this.domain}/api/elementConditionLogic`,
                elementConditionLogicData,
                {
                    headers: this.headers,
                }
            )
        );
    }

    async update(elementConditionLogicData: ElementConditionLogic[], elementId: string) {
        return await lastValueFrom(
            this.http.put<ElementConditionLogic[]>(
                `${this.domain}/api/elementConditionLogic`,
                elementConditionLogicData,
                {
                    headers: this.headers,
                    params: { elementId },
                }
            )
        );
    }
}
